<div class="row justify-content-center g-0">
  <div class="col-xs-12 col-sm-10 col-md-8 col-lg-6">

    @if(!processing()) {
      @if(pool && poolUser){
          @let tmplCurrentGameRound = currentGameRound();
          <div class="d-flex flex-nowrap justify-content-between mt-2 mx-1">
            <h1 class="me-2 text-truncate">            
              <fa-icon [icon]=faUser></fa-icon> {{getHeaderForPoolUser(poolUser)}}
            </h1>
            
            @if(tmplCurrentGameRound && isNowAfterTransferPeriod(pool.getCompetitionConfig())){  
              <app-period-selector
                [competitionConfig]="pool.getCompetitionConfig()"
                [activePeriod]="tmplCurrentGameRound.viewPeriod"
                (selectPeriod)="selectPeriod(pool, $event)"
              ></app-period-selector>
            }            
                      
            <div>
              <button (click)="openChooseBadgeCategoryModal()" type="button"
                class="btn {{badgeCategory() !== undefined ? 'btn-success' : 'btn-outline-dark'}} me-0 position-relative">
                <app-superelf-icon [icon]=facTrophy></app-superelf-icon>
              </button>
            </div>
          </div>   

        <div class="d-flex justify-content-between mb-1 mx-1">
          
          <div class="mt-0">         
            
            <!-- @if(tmplCurrentGameRound){
              <div class="d-flex justify-content-between mt-3 mb-1 mx-1">
                <app-gameround-scroller 
                  [viewPeriod]="tmplCurrentGameRound.viewPeriod"
                  [gameRounds]="viewGameRounds()"
                  [activeGameRound]="tmplCurrentGameRound"
                  [previousGameRound]="previousGameRound()"
                  (previous)="selectPreviousGameRound(pool.getCompetitionConfig(), tmplCurrentGameRound)"
                  [nextGameRound]="nextGameRound()"                               
                  (next)="selectNextGameRound(pool.getCompetitionConfig(), tmplCurrentGameRound)"         
                  [competitionConfig]="pool.getCompetitionConfig()"
                  (selectViewPeriod)="selectViewPeriod(pool, $event)"
                  (selectGameRound)="selectGameRound(poolUser, $event)"
                  (selectTransferPeriod)="openPoolUserTransfersModal()"
                ></app-gameround-scroller>
              </div>
            }  -->
          </div>
        </div>

        @if(!processingStatistics()){
          @let tmplCurrentGameRound = currentGameRound();
          @let competitionConfig = pool.getCompetitionConfig();
          <div>
            <!-- lines-->
            @let tmplAssembleFormation = assembleFormation();
            @let tmplTransferFormation = transferFormation();
            @let viewFormation = tmplTransferFormation ?? tmplAssembleFormation;
            @if(tmplCurrentGameRound && viewFormation && pool){
              <table class="table">
                <colgroup style="width: 100%">
                  <col style="width: 35%">
                  <col style="width: 14%;">
                  @for(viewGameRound of viewGameRounds(); track $index) {
                    <col style="width: 17%">
                  }
                  <col style="width: 17%">
                </colgroup>
                <thead app-competition-gameround-scroller         
                      [viewPeriod]="tmplCurrentGameRound.viewPeriod"
                      [previousGameRound]="previousGameRound()"
                      [gameRounds]="viewGameRounds()"
                      [nextGameRound]="nextGameRound()"
                      [activeGameRound]="tmplCurrentGameRound"
                      [previousColSpan]="2"
                      (previousPressed)="selectPreviousGameRound(pool.getCompetitionConfig(), tmplCurrentGameRound)"
                      (gameRoundPressed)="openGameRoundInfoModal(pool.getCompetitionConfig(), $event)"          
                      (nextPressed)="selectNextGameRound(pool.getCompetitionConfig(), tmplCurrentGameRound)"                      
                    >      
                </thead>   
                @for(line of viewFormation.getLines();track line.getNumber()) {                  
                  <tbody app-pool-formationline-view [line]="line"
                      [statisticsGetter]="statisticsGetter" [gameRounds]="viewGameRounds()" 
                      [missingPlayerGamesMap]="missingPlayerGamesMap()"
                      [totalPoints]="line.getNumber() === GoalKeeper ? viewFormation.getTotalPoints(undefined) : undefined"
                      [previousFormation]="viewFormation === tmplTransferFormation ? tmplAssembleFormation : undefined"
                      (linkToPlayer)="openPlayerModal($event, competitionConfig)"
                      (linkToMissingPlayer)="openPlayerStateModal($event, competitionConfig)">
                  </tbody>
                }
              </table>
            }
          </div>
        } @else {
          <h2 class="text-center">
            <fa-icon [icon]=faSpinner [animation]="'spin'"></fa-icon>
          </h2>
        }
      }      

      @if(alert) {
        <ngb-alert [type]="alert.type">{{ alert.message }}</ngb-alert>
      }



    } @else {
      <h2 class="text-center">
        <fa-icon [icon]=faSpinner [animation]="'spin'"></fa-icon>
      </h2>
    }    
    
  </div>
</div>
@if(!processing() && pool){
<app-pool-navbar [pool]="pool" [poolUser]="poolUser"></app-pool-navbar>
}